import React, { useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { StoreState } from '../../../store/createStore';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

//Actions
import { orderList } from '../../../store/modules/order/actions';
import { verifyEmailExist } from '../../../store/modules/auth/actions';

//Hooks
import { useTranslation } from '../../../hooks/useTranslation';
import { removeAccountCustomer } from '../../../store/modules/auth/actions';
import getValidationErrors from '../../../utils/getValidationErrors';

//Components
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Loading from '../../../components/Loading';

//Styles
import { ContainerRemoveAccount, ColInput, ContainerFooter, ContainerEmailVerification } from './styles';
import { Title } from '../styles';

//Types
import { orderListProps } from '../../../store/modules/order/types';
interface removeAccountCustomerProps {
  email: string;
}

const RemoveAccount: React.FC = () => {
  const dispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { loading, user, emailExists } = useSelector((state: StoreState) => state.auth);
  const { orders, loading: loadingOrders } = useSelector((state: StoreState) => state.order);
  const { checkout } = useSelector((state: StoreState) => state.checkout);
  const { onTranslation: t } = useTranslation();

  useEffect(() => {
    const requestOrder: orderListProps = {
      customer_id: user.data.id,
    };
    dispatch(orderList(requestOrder));
    dispatch(verifyEmailExist('-'));
  }, [dispatch, user]);

  const handleVerifyEmail = useCallback(async (data: removeAccountCustomerProps) => {
    try {

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        email: Yup.string().required(`${t('main.messages_yup.email_required')}`),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      // //Verificando se há pedidos pendentes
      if (orders !== undefined) {
        if (orders.orders !== undefined) {
          if (Object.keys(orders.orders).length !== 0) {
            const orderStatus = orders.orders[0].status as string

            if (orderStatus !== 'completed' && orderStatus !== 'canceled') {
              toast.error(t('main.new_account.remove_account.thereAreAnyOrderOpen'));
              return;
            }
          }
        }
      }

      // //Verificando se há itens no carrinho
      if (checkout.items_count !== 0) {
        toast.error(t('main.new_account.remove_account.removeItemsFromCart'));
        return;
      }

      //Verificando se o usuário existe
      if (data.email === user.data.email) {
        dispatch(verifyEmailExist(data.email, t('main.new_account.remove_account.emailVerified')));
      } else {
        toast.error(t('main.new_account.remove_account.errorEmail'));
      }

    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current?.setErrors(errors);
      }
    }
  }, [dispatch, t, orders, checkout, user]);

  const handleCancelAccount = useCallback(() => {
    dispatch(removeAccountCustomer(`${t('main.messages_toast.remove_account_success')}`));
  }, [dispatch, t]);

  if (loading || loadingOrders) {
    return <Loading size={160} />
  }

  return (
    <ContainerRemoveAccount>
      <Title>
        <span>{t('main.new_account.remove_account.title_remove_account')}</span>
      </Title>
      <Form
        ref={formRef}
        onSubmit={handleVerifyEmail}
      >
        <ContainerEmailVerification>

          <ColInput>
            <Input
              type="email"
              name="email"
              textLabel={t('main.modal_login.input_email')}
            />
          </ColInput>


          <div className='verifyEmail'>
            <Button
              button={{ type: 'submit' }}
              atributes={{
                buttonType: 'success',
                textColor: '#fff',
                textSize: '18px',
                borderColor: '#dddddd',
                padding: '0'
              }}
            >
              {t('main.new_account.remove_account.buttonVerifyEmail')}
            </Button>
          </div>
        </ContainerEmailVerification>
      </Form>


      {loading || loadingOrders ? (
        <Loading size={160} />
      )
        :
        (


          <ContainerFooter >
            <button
              onClick={handleCancelAccount}
              disabled={emailExists === true ? false : true}
            >
              {t('main.new_account.remove_account.button_remove_account')}
            </button>
          </ContainerFooter>
        )
      }
    </ContainerRemoveAccount>
  );
}

export default RemoveAccount;
